import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { ApplicationState } from '../../../../store';
import Checklist, { IDispatchProps, IProps } from './index';

import {
  PI1Risk,
  PI2Risk,
  PI3Risk,
  PI4Risk,
  PI5Risk,
  PI6Risk,
  PI7Risk,
  PI8Risk,
  PI9Risk,
  PI10Risk,
  H1Risk,
  H2Risk,
  H3Risk,
  F1Risk,
} from '../../../../store/student/risks/reducer';
import { boolToYesNo, formatCurrency } from '../../../../utilities/formatting';
import {
  canShowAgentQuestion,
  canShowVisaSupportQuestion,
  canShowWhatsappQuestion,
  canShowOfferEvidenceQuestion,
} from '../../../../utilities/pages';
import { updateRisks } from '../../../../store/student/actions';

export const mapStateToProps = (state: ApplicationState): IProps => {
  const {
    isPIPage1Complete: PIP1 = false,
    isPIPage2Complete: PIP2 = false,
    isPIPage3Complete: PIP3 = false,
    isPIPage4Complete: PIP4 = false,
    isPIPage5Complete: PIP5 = false,
    isPIPage5_1Complete: PIP5_1 = false,
    isPIPage6Complete: PIP6 = false,
    isPIPage7Complete: PIP7 = false,
    isPIPage8Complete: PIP8 = false,
    isPIPage9Complete: PIP9 = false,
    isPIPage10Complete: PIP10 = false,
  } = state.student.offer;

  const {
    isHPage1Complete: HP1 = false,
    isHPage2Complete: HP2 = false,
    isHPage3Complete: HP3 = false,
  } = state.student.offer;

  const {
    isPage1Complete: CP1 = false,
    isPage2Complete: CP2 = false,
    isPage3Complete: CP3 = false,
    isPage4Complete: CP4 = false,
  } = state.student.consents;

  const FP1 = !!state.student.financials.isSectionComplete;

  const {
    Page1: PIPage1,
    Page2: PIPage2,
    Page3: PIPage3,
    Page4: PIPage4,
    Page5: PIPage5,
    Page5_1: PIPage5_1,
    Page6: PIPage6,
    Page7: PIPage7,
    Page8: PIPage8,
    Page9: PIPage9,
    Page10: PIPage10,
  } = state.student.config.Checklist.PersonalInfo;

  const { Page1: HPage1, Page2: HPage2, Page3: HPage3 } = state.student.config.Checklist.History;
  const { historySectionStatus } = state.student.config;

  const { Page1: CPage1, Page2: CPage2, Page3: CPage3, Page4: CPage4 } = state.student.config.Checklist.Consents;

  const { Page1: FPage1 } = state.student.config.Checklist.Finances;
  const { financeSectionStatus } = state.student.config;

  const showAgentQuestion = canShowAgentQuestion(state.student.importData, state.auth.role, state.student.offer);

  const showVisaSupportQuestion = canShowVisaSupportQuestion(
    state.student.personalInfo,
    state.student.importData,
    state.student.config,
    state.auth.role,
    state.student.offer,
  );
  const showWhatsappQuestion = canShowWhatsappQuestion(state.student.offer, state.auth.role);
  const showOfferEvidenceQuestion = canShowOfferEvidenceQuestion(
    state.student.offer,
    state.student.importData,
    state.student.conflictHistory,
    state.student.config.evidenceForOfferInCourseDetails,
  );

  // prettier-ignore
  const statusArray = [
    ...( !PIPage1.hidden ? [{finger: 'PIP1', title: PIPage1.title, complete: PIP1, risk: PI1Risk(state.student.risks, state.auth.role)}] : []),
    ...( !PIPage2.hidden ? [{finger: 'PIP2', title: PIPage2.title, complete: PIP2, risk: PI2Risk(state.student.risks, state.auth.role)}] : []),
    ...( !PIPage3.hidden ? [{finger: 'PIP3', title: PIPage3.title, complete: PIP3, risk: PI3Risk(state.student.risks, state.auth.role)}] : []),
    ...( !PIPage4.hidden ? [{finger: 'PIP4', title: PIPage4.title, complete: PIP4, risk: PI4Risk(state.student.risks, state.auth.role)}] : []),
    ...( !PIPage5.hidden ? [{finger: 'PIP5', title: PIPage5.title, complete: PIP5, risk: PI5Risk(state.student.risks, state.auth.role)}] : []),
    ...( !PIPage5_1.hidden && showOfferEvidenceQuestion ? [{finger: 'PIP5_1', title: PIPage5_1.title, complete: PIP5_1, risk: false}] : []),
    ...( !PIPage6.hidden ? [{finger: 'PIP6', title: PIPage6.title, complete: PIP6, risk: PI6Risk(state.student.risks, state.auth.role)}] : []),
    ...( !PIPage7.hidden ? [{finger: 'PIP7', title: PIPage7.title, complete: PIP7, risk: PI7Risk(state.student.risks, state.auth.role)}] : []),
    ...( !PIPage8.hidden && showAgentQuestion
      ? [{finger: 'PIP8', title: PIPage8.title, complete: PIP8, risk: PI8Risk(state.student.risks, state.auth.role)}] : []),
    ...( (!PIPage9.hidden && showVisaSupportQuestion)
          ? [{finger: 'PIP9', title: PIPage9.title, complete: PIP9, risk: PI9Risk(state.student.risks, state.auth.role)}]
          : []),
    ...( (!PIPage10.hidden && showWhatsappQuestion)
          ? [{finger: 'PIP10', title: PIPage10.title, complete: PIP10, risk: PI10Risk(state.student.risks, state.auth.role)}]
          : []),
    {finger: 'HP1', title: HPage1.title, complete: HP1, risk: H1Risk(state.student.risks, state.auth.role)},
    {finger: 'HP2', title: HPage2.title, complete: HP2, risk: H2Risk(state.student.risks, state.auth.role)},
    {finger: 'HP3', title: HPage3.title, complete: HP3, risk: H3Risk(state.student.risks, state.auth.role)},
    ...( !CPage1.hidden ? [{finger: 'CP1', title: CPage1.title, complete: CP1, risk: false}] : []),
    ...( !CPage2.hidden ? [{finger: 'CP2', title: CPage2.title, complete: CP2, risk: false}]: []),
    ...( (!CPage3.hidden && state.student.offer.visaSupport) ? [{finger: 'CP3', title: CPage3.title, complete: CP3, risk: false}]: []),
    ...( !CPage4.hidden ? [{finger: 'CP4', title: CPage4.title, complete: CP4, risk: false}]: []),
    {finger: 'FP1',  title: FPage1.title, complete: FP1, risk: F1Risk(state.student.risks, state.auth.role)}
  ];

  const {
    hasOtherNames,
    middleName,
    otherNames,
    appliedForEUSS,
    grantedEUSSStatus,
    applyingFromHomeCountry,
    countryOfVisaApplication,
    livedInUKLast12Months,
    otherCountryReason,
    hasOtherNationality,
    otherNationalities,
    birthCountry: countryOfBirth,
    homeAddress: address,
    city,
    postCode,
    country,
    studentNo,
    phoneNumber,
    hasCriminalConvictions,
    criminalConvictionReason,
    courseFeeDepositReqd,
    courseFeeDeposit,
    courseFeeDepositDate,
    courseFeeDepositNotReqdReason,
    accomDepositReqd,
    accomDeposit,
    accomDepositDate,
    hasEnglishTest,
    englishTestType,
    englishTestTypeOther,
    passportExpiryDate: passportExpiry,
    passportExpectedDate: passportExpected,
    withAgent,

    useWhatsapp,
    whatsAppPhoneNumber,

    lastCourse,
    lastCourseOther,
    lastCourseYear,
    hasOverseasTravel,
    overseasTravelTimes,
    hasUkTravel,
    ukTravelTimes,
    hasPreviousUkStudyVisa,
    hasPreviousUkStudy,
    previousUkStudyVisas,

    hasOtherUkVisas,
    otherUkVisas,
    hasLeaveToRemain,
    hasBorderRefusal,
    borderRefusalReason,
    hasUkVisaRefusals,
    ukVisaRefusals,
    hasOtherVisaRefusals,
    otherVisaRefusals,
  } = {
    ...state.student.personalInfo,
    ...state.student.history,
    ...state.student.financials,
  };

  const {
    courses = [],
    visaSupport,
    hasDependents,
    hasChildren,
    childrenNum,
    hasPartner,
    partnerVisaStatus,
  } = state.student.offer;

  const { organisationSponsorship, scholarshipSponsorship, educationSponsorship, familySponsorship, otherSponsorship } =
    state.student.financials;

  return {
    statusArray,
    ...state.student.personalInfo,
    ...state.student.history,
    historySectionStatus,
    financeSectionStatus,
    organisationSponsorship: organisationSponsorship ?? {},
    scholarshipSponsorship: scholarshipSponsorship ?? {},
    educationSponsorship: educationSponsorship ?? {},
    familySponsorship: familySponsorship ?? {},
    otherSponsorship: otherSponsorship ?? {},
    hasOtherNames: boolToYesNo(hasOtherNames),
    middleName,
    otherNames,
    appliedForEUSS,
    grantedEUSSStatus,
    applyingFromHomeCountry: boolToYesNo(applyingFromHomeCountry),
    countryOfVisaApplication,
    livedInUKLast12Months,
    otherCountryReason,
    hasOtherNationality: boolToYesNo(hasOtherNationality),
    otherNationalities,
    countryOfBirth,
    address,
    city,
    postCode,
    country,
    phoneNumber,
    hasCriminalConvictions: boolToYesNo(hasCriminalConvictions),
    criminalConvictionReason,
    // isResearchStudent: isResearchStudent ?? false,
    courseFeeDepositReqd: courseFeeDepositReqd ?? '',
    courseFeeDeposit: `£${formatCurrency(courseFeeDeposit ?? 0)}`,
    courseFeeDepositDate: courseFeeDepositDate ?? '',
    courseFeeDepositNotReqdReason: courseFeeDepositNotReqdReason ?? '',
    accomDepositReqd: accomDepositReqd ?? '',
    accomDeposit: `£${formatCurrency(accomDeposit ?? 0)}`,
    accomDepositDate: accomDepositDate ?? '',
    hasEnglishTest: boolToYesNo(hasEnglishTest),
    visaSupport: boolToYesNo(visaSupport),
    useWhatsapp,
    whatsAppPhoneNumber,
    englishTestType,
    englishTestTypeOther,
    studentNo,
    courses,
    passportExpiry,
    passportExpected,
    withAgent,

    lastCourse,
    lastCourseOther,
    lastCourseYear,
    hasOverseasTravel: boolToYesNo(hasOverseasTravel),
    overseasTravelTimes,
    hasUkTravel: boolToYesNo(hasUkTravel),
    ukTravelTimes,
    hasPreviousUkStudyVisa: boolToYesNo(hasPreviousUkStudyVisa),
    hasPreviousUkStudy: boolToYesNo(hasPreviousUkStudy),
    previousUkStudyVisas,

    hasOtherUkVisas: boolToYesNo(hasOtherUkVisas),
    otherUkVisas,
    hasLeaveToRemain: boolToYesNo(hasLeaveToRemain),
    hasBorderRefusal: boolToYesNo(hasBorderRefusal),
    borderRefusalReason,
    hasUkVisaRefusals: boolToYesNo(hasUkVisaRefusals),
    ukVisaRefusals,
    hasOtherVisaRefusals: boolToYesNo(hasOtherVisaRefusals),
    otherVisaRefusals,
    hasDependents: boolToYesNo(hasDependents),
    hasPartner: boolToYesNo(hasPartner),
    partnerVisaStatus: String(partnerVisaStatus),
    hasChildren: boolToYesNo(hasChildren),
    childrenNum: String(childrenNum),

    riskList: state.student.risks,
    userRole: state.auth.role,
    personalInfoTitle: state.student.config.Checklist.PersonalInfo.shortTitle,
    yourHistoryTitle: state.student.config.Checklist.History.shortTitle,
    consentsTitle: state.student.config.Checklist.Consents.shortTitle,
    financialTitle: state.student.config.Checklist.Finances.shortTitle,
    config: state.student.config,
  };
};

function mapDispatchToProps(dispatch: Dispatch): IDispatchProps {
  return {
    onUpdateRisks: (source: string, clearedRisks: any) => dispatch(updateRisks({ source, clearedRisks })),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Checklist);
